export { default } from './CopyContent';
export * from './CopyContent';
